import cn from 'classnames'
import styles from './RoomSelectionService.module.css'

interface FlexContentProps {
  gap: string
  children: React.ReactNode
  className?: string
}

export function FlexContent({ gap, children, className }: FlexContentProps) {
  return (
    <div
      className={cn(styles.flexContent, className)}
      style={gap ? { gap: `var(--${gap})` } : undefined}
    >
      {children}
    </div>
  )
}
